import { C, wrap, SectionLabel } from '../styles';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import CTASection from '../content/CTASection';
import { useDocumentMeta } from '../content/useDocumentMeta';

export default function LocationLayout({ title, description, heading, children }) {
  useDocumentMeta(title, description);

  return (
    <>
      <Nav />

      <section style={{ padding: '64px 0 20px', borderBottom: `1px solid ${C.bdr}` }}>
        <div style={wrap}>
          <SectionLabel>Service area</SectionLabel>
          <h1 style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: 'clamp(30px, 5vw, 48px)',
            fontWeight: 700, lineHeight: 1.08,
            textTransform: 'uppercase', color: C.txt,
            maxWidth: 780, marginBottom: 16,
          }}>{heading}</h1>
          <p style={{ color: C.mut, fontSize: 16, lineHeight: 1.7, maxWidth: 640 }}>{description}</p>
        </div>
      </section>

      <section style={{ padding: '48px 0 8px' }}>
        <div style={{ ...wrap, maxWidth: 760 }}>
          {children}
        </div>
      </section>

      <CTASection />

      <Footer />
    </>
  );
}
